import { render } from "./whr-footer.vue?vue&type=template&id=37a2ad8a&scoped=true&ts=true"
import script from "./whr-footer.vue?vue&type=script&lang=ts"
export * from "./whr-footer.vue?vue&type=script&lang=ts"

import "./whr-footer.vue?vue&type=style&index=0&id=37a2ad8a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a2ad8a"]])

export default __exports__